import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useMemo, useState } from "react";
import dummyLogo from "../../asset/avathar.jpg";

const AttendanceTable = ({ data = [] }) => {
  const [search, setSearch] = useState("");

  /* 🔍 FILTER DATA */
  const filteredData = useMemo(() => {
    return data.filter(d =>
      d.StudentName?.toLowerCase().includes(search.toLowerCase()) ||
      d.ParentUserName?.toLowerCase().includes(search.toLowerCase()) ||
      d.ParentPhoneNumber?.includes(search) ||
      d.BatchName?.toLowerCase().includes(search.toLowerCase()) ||
      d.BranchName?.toLowerCase().includes(search.toLowerCase())
    );
  }, [data, search]);

  /* 📦 EXPORT DATA */
  const getExportData = () =>
    filteredData.map(d => ({
      Student: d.StudentName,
      Status: d.Status,
      Parent: d.ParentUserName,
      Phone: d.ParentPhoneNumber,
      Batch: d.BatchName,
      Branch: d.BranchName,
      Date: d.AttendanceDate,
    }));

  /* 📥 EXCEL */
  const downloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(getExportData());
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    saveAs(
      new Blob([excelBuffer], { type: "application/octet-stream" }),
      "Attendance_Report.xlsx"
    );
  };

  /* 📥 CSV */
  const downloadCSV = () => {
    const sheet = XLSX.utils.json_to_sheet(getExportData());
    const csv = XLSX.utils.sheet_to_csv(sheet);

    saveAs(
      new Blob([csv], { type: "text/csv;charset=utf-8;" }),
      "Attendance_Report.csv"
    );
  };

  return (
    <div className="table-card">
      {/* 🔍 TOOLBAR (TEMPLATE STYLE) */}
      <div className="table-toolbar">
        <input
          type="text"
          className="search-input"
          placeholder="Search student / parent / phone / batch / branch..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <div className="table-actions">
          <button onClick={downloadExcel}>⬇ Excel</button>
          <button onClick={downloadCSV}>⬇ CSV</button>
        </div>
      </div>

      {/* 📋 TABLE */}
      <div className="table-wrapper">
        <table className="students-table">
          <thead>
            <tr>
              <th>Student</th>
              <th>Status</th>
              <th>Parent</th>
              <th>Phone</th>
              <th>Batch</th>
              <th>Branch</th>
              <th>Date</th>
            </tr>
          </thead>

          <tbody>
            {filteredData.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center">
                  No matching attendance records
                </td>
              </tr>
            ) : (
              filteredData.map((row, i) => (
                <tr key={i}>
                  <td>
                    <div className="student-cell">
                      <img
                        src={row.StudentProfilePicUrl || dummyLogo}
                        alt={row.StudentName}
                        onError={(e) => (e.currentTarget.src = dummyLogo)}
                      />
                      <span>{row.StudentName}</span>
                    </div>
                  </td>

                  <td>
                    <span className={`status ${row.Status.toLowerCase()}`}>
                      {row.Status}
                    </span>
                  </td>

                  <td>{row.ParentUserName}</td>
                  <td>{row.ParentPhoneNumber}</td>
                  <td>{row.BatchName}</td>
                  <td>{row.BranchName}</td>
                  <td>{row.AttendanceDate}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AttendanceTable;
